export default __webpack_public_path__ + "static/hq3-a56dec1873543a2ed86ec41d37c92ec1.jpg";